import { render, staticRenderFns } from "./popus.vue?vue&type=template&id=7ab67076&scoped=true&"
import script from "./popus.vue?vue&type=script&lang=js&"
export * from "./popus.vue?vue&type=script&lang=js&"
import style0 from "./popus.vue?vue&type=style&index=0&id=7ab67076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab67076",
  null
  
)

export default component.exports